import { getReadableRelativeTime } from './getReadableRelativeTime.js';
import { htmlEscape } from './htmlEscape.js';
import { humanReadableByteSize } from './humanReadableByteSize.js';
import { trackTime } from './trackTime.js';

const misc = {
    getReadableRelativeTime,
    htmlEscape,
    humanReadableByteSize,
    trackTime
};

export { misc };
